export default (phoneNumber: string): string => {
  return phoneNumber.replace(/[^\w ]|\s+/g, '');
};
